var map = {
	"./Colorful": 57143,
	"./Colorful.js": 57143,
	"./Colorful.module.css": 45693,
	"./DisplayItems": 91747,
	"./DisplayItems.js": 91747,
	"./DisplayItems.module.css": 34273,
	"./InsertText": 43011,
	"./InsertText.js": 43011,
	"./InsertText.module.css": 87457,
	"./ReadItOut": 13258,
	"./ReadItOut.js": 13258,
	"./ReadItOut.module.css": 89500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48057;